import * as yup from "yup";
import { useUser } from "../../providers/users";
import Loading from "../Loading";
import { Container } from "./styles";

import { yupResolver } from "@hookform/resolvers/yup";
import { Button, FormHelperText, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useTenant } from "../../providers/tenant";
import { useState } from "react";
import { useNotification } from "../../providers/notifications";
const WhatsappUpdateForm = () => {
  const { apiLoading } = useUser();
  const { updateIntegrations, tenant } = useTenant();
  const { t } = useTranslation();
  const { sendTestWhatsapp } = useNotification();
  const [WhatsappTest, setWhatsappTest] = useState("");
  type FormValues = yup.InferType<typeof formSchema>;
  const onSubmit = async (data: FormValues) => {
    await updateIntegrations({ twilioWhatsapp: data });
  };

  const formSchema = yup
    .object()
    .shape({
      name: yup.string().required(t("field_required")).max(128, t("field_max")),
      accountSid: yup
        .string()
        .required(t("field_required"))
        .max(128, t("field_max")),
      authToken: yup
        .string()
        .required(t("field_required"))
        .max(128, t("field_max")),
      messagingServiceSid: yup
        .string()
        .required(t("field_required"))
        .max(128, t("field_max")),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h3>Twilio</h3>
        <TextField
          error={errors.name === undefined ? false : true}
          helperText={errors.name?.message?.toString()}
          defaultValue={
            tenant.integrations.twilioWhatsapp &&
            tenant.integrations.twilioWhatsapp.name
          }
          id="standard-name"
          label={t("name")}
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          sx={{
            boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",

            textAlign: "center",
            backgroundColor: "#FFF",
            "& fieldset": { border: "none" },
          }}
          {...register("name")}
        />
        <TextField
          id="standard-accountSid"
          error={errors.accountSid === undefined ? false : true}
          helperText={errors.accountSid?.message?.toString()}
          defaultValue={
            tenant.integrations.twilioWhatsapp &&
            tenant.integrations.twilioWhatsapp.accountSid
          }
          label="Account SID"
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          sx={{
            boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",

            textAlign: "center",
            backgroundColor: "#FFF",
            "& fieldset": { border: "none" },
          }}
          {...register("accountSid")}
        />

        <TextField
          id="standard-authToken"
          error={errors.authToken === undefined ? false : true}
          helperText={errors.authToken?.message?.toString()}
          defaultValue={
            tenant.integrations.twilioWhatsapp &&
            tenant.integrations.twilioWhatsapp.authToken
          }
          label="Auth token"
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          sx={{
            boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",

            textAlign: "center",
            backgroundColor: "#FFF",
            "& fieldset": { border: "none" },
          }}
          {...register("authToken")}
        />
        <TextField
          id="standard-messagingServiceSid"
          error={errors.messagingServiceSid === undefined ? false : true}
          helperText={errors.messagingServiceSid?.message?.toString()}
          defaultValue={
            tenant.integrations.twilioWhatsapp &&
            tenant.integrations.twilioWhatsapp.messagingServiceSid
          }
          label="Messaging ID"
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          sx={{
            boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",

            textAlign: "center",
            backgroundColor: "#FFF",
            "& fieldset": { border: "none" },
          }}
          {...register("messagingServiceSid")}
        />

        {tenant.integrations.twilioWhatsapp && (
          <div className="testDiv">
            <TextField
              id="standard-WhatsappFrom"
              label="Send test Whatsapp"
              placeholder="+000000000000"
              variant="filled"
              InputProps={{
                disableUnderline: true,
              }}
              value={WhatsappTest}
              onChange={(e) => setWhatsappTest(e.target.value)}
              sx={{
                boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",
                width: "100%",
                textAlign: "center",
                backgroundColor: "#FFF",
                "& fieldset": { border: "none" },
              }}
            />
            <Button
              onClick={() => {
                if (!WhatsappTest) {
                  return;
                }

                sendTestWhatsapp(WhatsappTest);
              }}
              sx={{ borderRadius: "25px", width: 150, ml: 1 }}
              variant="contained"
              disabled={apiLoading || !WhatsappTest}
              size="small"
            >
              Send
            </Button>
          </div>
        )}

        {apiLoading ? (
          <Loading />
        ) : (
          <div>
            <Button
              type="submit"
              sx={{ borderRadius: "25px" }}
              variant="contained"
            >
              save
            </Button>
          </div>
        )}
      </form>
    </Container>
  );
};

export default WhatsappUpdateForm;
